module.exports = __webpack_public_path__ + "static/media/WEO76REQ0002.832148e1.svg";